import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-cri-profile-dialog.controller';
import template from './edit-cri-profile-dialog.html';

class dialogService {
  getOptions($event, { assessmentId, criProfile, assessment }) {
    return {
      controller,
      controllerAs: 'editCRIProfileDialogVM',
      locals: {
        assessmentId,
        criProfile,
        assessment
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.editCRIProfileDialog', [
  alerts,
  constants,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
])
  .service('editCRIProfileDialog', dialogService)
  .name;
